import React, { useContext, useEffect, useState } from "react";
import { Box, Divider, Stack } from "digiwash-components";
import { useServices } from "../../hooks/useServices";
import ServicesItem from "../../components/ServicesItem/ServicesItem-component";
import SkeletonServices from "../../components/SkeletonServices";
import ServerError from "../../components/ServerError";
import { Helmet } from "react-helmet";
import useCart from "../../ducks/cart/hooks/useCart";
import { CartRetrieveOutput, Item } from "../../ducks/cart/cart-types";
import { ListServicesType } from "../../types/server";
import ModalService from "../../components/ModalService";
import { LoginContext } from "../../contexts/login";
import { logEvent } from "../../helpers/analytics-helper";
import { services_list_to_ga_item_list } from "../../helpers/ga-helper";
import { EVENT_TYPES } from "../../types/analytics-type";
import {
  suggestResponsiveBoxRatioForServices,
  suggestResponsiveColumnForServices,
} from "../../helpers/general";

function badge(
  items: Item[] | undefined,
  list: ListServicesType[] | undefined
) {
  let output = [];

  if (!items || !list) {
    return output;
  }

  items.forEach((item) => {
    list.forEach((listItem) => {
      if (listItem.children.length === 0 && item.service === listItem.id) {
        output.push(item.service);
      } else if (listItem.children.length > 0) {
        listItem.children.forEach((childrenItem) => {
          if (item.service === childrenItem.id) {
            output.push(listItem.id);
          }
        });
      }
    });
  });

  return output.reduce(function (prev, cur) {
    prev[cur] = (prev[cur] || 0) + 1;
    return prev;
  }, {});
}

function Services(props) {
  let { retrive, servicesData, loading, error } = useServices();
  let [modalVisible, setModalVisible] = useState(false);
  let [selectedService, setSelectedService] = useState(undefined);

  let { retrieve: retrieveCart } = useCart();
  let cart: CartRetrieveOutput = retrieveCart({ force: true });
  let { setLoginModalOpen } = useContext(LoginContext);

  let dismiss = () => {
    setModalVisible(false);
    setSelectedService(undefined);
  };

  useEffect(() => {
    retrive(props.filter);
  }, [props.filter]);

  useEffect(() => {
    if (servicesData) {
      logEvent(
        EVENT_TYPES.VIEW_ITEM_LIST,
        services_list_to_ga_item_list(
          `services_by_category_${props.filter}`,
          `دسته‌بندی ${props.filter}`,
          servicesData.data.listServices
        )
      );
    }
  }, [servicesData]);

  return (
    <>
      {loading && <SkeletonServices />}
      {error && (
        <>
          <Helmet>
            <title>مشکل در اتصال به سرور</title>
          </Helmet>
          <Box style={{ width: "100%" }}>
            <Divider size="xxxl" />
            <ServerError
              action={() => {
                retrive(props.filter);
              }}
              error={error}
            />
          </Box>
        </>
      )}

      {!loading && !error && servicesData?.data?.listServices ? (
        <Stack
          px="l"
          style={{ width: "100%" }}
          distribution="space-between"
          columns={suggestResponsiveColumnForServices(
            suggestResponsiveBoxRatioForServices().column
          )}
          fillIfEmpty
        >
          {servicesData?.data?.listServices.map((item) => {
            return (
              <ServicesItem
                data={item}
                onSelect={(service) => {
                  setSelectedService(service);
                  setModalVisible(true);
                }}
                badge={badge(
                  cart?.data?.items,
                  servicesData?.data?.listServices
                )}
              />
            );
          })}
        </Stack>
      ) : null}

      <ModalService
        visible={modalVisible}
        dismiss={dismiss}
        selectedService={selectedService}
        onLogin={() => {
          setModalVisible(false);
          setLoginModalOpen(true);
        }}
      />
    </>
  );
}

export default Services;
